import { useEffect, useState } from "react";
import { ManipulationType } from "gql/graphql";
import { useSubscription } from "@apollo/client";
import { AI_MANIPULATE_TEXT_SUBSCRIPTION } from "@/modules/ai/features/manipulate-text/api/ai-manipulate-text-subscription";
import { useAiGenerationState } from "@/modules/ai/shared/model/use-ai-generation-state";

export function useAiTextManipulation({ value }: { value?: string }) {
  const [suggestion, setSuggestion] = useState("");

  const [manipulationType, setManipulationType] =
    useState<ManipulationType | null>(null);

  const { generating, start, finish } = useAiGenerationState();

  const { data, restart } = useSubscription(AI_MANIPULATE_TEXT_SUBSCRIPTION, {
    variables: {
      text: value as string,
      type: manipulationType as ManipulationType,
    },
    skip: !manipulationType || !value,
    onComplete: finish,
    onError: finish,
  });

  useEffect(() => {
    if (data?.aiManipulateText.__typename === "UpdateMessageAiChatMessage") {
      setSuggestion(data.aiManipulateText.text);
    }
  }, [data]);

  const manipulate = (type: ManipulationType) => {
    if (!value) return;

    start();

    // с теми же переменными подписка сама не перезапустится
    if (type === manipulationType) restart();
    else setManipulationType(type);
  };

  const cancel = () => {
    finish();
    setManipulationType(null);
    setSuggestion("");
  };

  return {
    suggestion,
    setSuggestion,
    manipulationType,
    manipulate,
    cancel,
    loading: generating,
  };
}
